module.exports = __webpack_public_path__ + "static/media/facebook-icon.53f6bf4c.png";